export const BlankIcon = () => (
  <svg
    width="144"
    height="144"
    viewBox="0 0 144 144"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="72" cy="72" r="72" fill="#EDEBE6" />
    <path
      d="M51.3334 46.6666H92.6667C94.037 46.6666 95.3511 47.211 96.3201 48.1799C97.289 49.1488 97.8334 50.463 97.8334 51.8333V86.7083H46.1667V51.8333C46.1667 50.463 46.711 49.1488 47.68 48.1799C48.6489 47.211 49.9631 46.6666 51.3334 46.6666V46.6666Z"
      fill="#7D5731"
    />
    <path
      d="M90.7812 89H54.2188C53.546 89 53 88.443 53 87.7568V44.2432C53 43.557 53.546 43 54.2188 43H90.7812C91.454 43 92 43.557 92 44.2432V87.7568C92 88.443 91.454 89 90.7812 89Z"
      fill="#E6E6E6"
    />
    <path
      d="M92.6667 45.375H51.3333C49.6211 45.3771 47.9796 46.0581 46.7689 47.2689C45.5581 48.4796 44.8771 50.1211 44.875 51.8333V93.1667C44.8771 94.8789 45.5581 96.5204 46.7689 97.7311C47.9796 98.9419 49.6211 99.6229 51.3333 99.625H92.6667C94.3789 99.6229 96.0204 98.9419 97.2311 97.7311C98.4419 96.5204 99.1229 94.8789 99.125 93.1667V51.8333C99.1229 50.1211 98.4419 48.4796 97.2311 47.2689C96.0204 46.0581 94.3789 45.3771 92.6667 45.375ZM51.3333 47.9583H92.6667C93.6944 47.9583 94.68 48.3666 95.4067 49.0933C96.1334 49.82 96.5417 50.8056 96.5417 51.8333V76.375H82.3333C81.9908 76.375 81.6622 76.5111 81.42 76.7533C81.1778 76.9956 81.0417 77.3241 81.0417 77.6667V84.125H62.9583V77.6667C62.9583 77.3241 62.8222 76.9956 62.58 76.7533C62.3378 76.5111 62.0092 76.375 61.6667 76.375H47.4583V51.8333C47.4583 50.8056 47.8666 49.82 48.5933 49.0933C49.32 48.3666 50.3056 47.9583 51.3333 47.9583Z"
      fill="#BF8C5A"
    />
    <path
      d="M70.042 71.0836C69.7326 71.0836 69.4233 70.9652 69.1877 70.7296L64.3543 65.8963C63.8819 65.4238 63.8819 64.6601 64.3543 64.1877C64.8268 63.7152 65.5905 63.7152 66.0629 64.1877L70.042 68.1667L78.8543 59.3543C79.3268 58.8819 80.0905 58.8819 80.5629 59.3543C81.0354 59.8268 81.0354 60.5905 80.5629 61.0629L70.8963 70.7296C70.6606 70.9652 70.3513 71.0836 70.042 71.0836Z"
      fill="#72C472"
    />
    <path
      d="M90.7812 48H54.2188C53.546 48 53 47.9637 53 47.9189V45.0811C53 45.0363 53.546 45 54.2188 45H90.7812C91.454 45 92 45.0363 92 45.0811V47.9189C92 47.9637 91.454 48 90.7812 48Z"
      fill="#E6E6E6"
    />
  </svg>
)
